// src/taskpane/tools/constants.ts

export const VALID_STYLES = [
  'Normal',
  'Heading1',
  'Heading2',
  'Heading3',
  'Heading4',
  'Title',
  'Subtitle',
  'Quote',
  'IntenseQuote',
  'ListParagraph',
  'NoSpacing',
] as const;

export const HIGHLIGHT_COLORS = [
  'Yellow',
  'Green',
  'Turquoise',
  'Pink',
  'Blue',
  'Red',
  'DarkBlue',
  'Teal',
  'Violet',
  'DarkRed',
  'DarkYellow',
  'Gray25',
  'Gray50',
  'Black',
  'White',
  'NoColor',
] as const;

export const FORMATTING_KEYS = [
  'bold',
  'italic',
  'underline',
  'underline_style',
  'strikethrough',
  'superscript',
  'subscript',
  'color',
  'size',
  'font',
  'highlight',
] as const;

/** Truncate text for result previews. */
export function preview(text: string, max = 80): string {
  return text.length > max ? text.slice(0, max) + '...' : text;
}
